import { inferQuestionScoring } from '../../questionScoring';
import type { ReportQuestion } from '../../types';
import type { ScaleSource, ScoreSource } from '../types';

/** Source constructors shared by the metric editor and its condition sub-editors. */
export const emptySource = (): ScoreSource => ({
  questionIndex: '',
  optionScores: [],
  min: 0,
  max: 1,
  rangeMode: 'mapped',
});

export function makeScoreSource(question: ReportQuestion): ScoreSource {
  const inferred = inferQuestionScoring(question).average;
  return {
    questionIndex: question.index,
    optionScores: inferred?.optionScores ?? (question.answersLocal ?? []).map(() => null),
    min: inferred?.min ?? 0,
    max: inferred?.max ?? 1,
    rangeMode: 'mapped',
  };
}

export function makeScaleSource(question: ReportQuestion): ScaleSource {
  return {
    questionIndex: question.index,
    questionType: question.type,
    optionScores: inferQuestionScoring(question).average?.optionScores ?? (question.answersLocal ?? []).map(() => null),
  };
}

/** An NPS source for `question`, inferring the 0–10 / 1–10 variant from its answers. */
export function makeNpsSource(question: ReportQuestion): { source: ScoreSource; inputMin: 0 | 1 } {
  const inferred = inferQuestionScoring(question).nps;
  return {
    source: inferred
      ? { questionIndex: question.index, optionScores: inferred.optionScores, min: inferred.minValue ?? 0, max: 10 }
      : { ...makeScoreSource(question), min: 0, max: 10 },
    inputMin: inferred?.minValue ?? (question.answersLocal?.length === 10 ? 1 : 0),
  };
}
